import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(orderDetailsButtonSetStyles, {
    ...orderDetailsButtonSetStyles,
    rmaButton: {
        variant: "primary",
    },
    cancelButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
                opacity: 0.9;
            }
        `,
    },
    printButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
                opacity: 0.9;
            }
        `,
    },
    reorderButton: {
        css: css`
            display: flex;
            align-items: center;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
    shareEntityButtonStyles: {
        button: {
            css: css`
                background-color: #999;
                border: none;
                :hover {
                    background-color: #999;
                    opacity: 0.9;
                }
            `,
        },
    },
});
